import * as React from 'react';
export const ACSvg = React.forwardRef(function ACSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 2H2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.35 5.96H0V4.04h3v-.11L.75 2.44a2 2 0 0 1 .94-.41L3 2.88V2h2v2.04h.05L8 2.08v1.04l-1.38.92H8v1.92H5v.09l2.93 1.94H6.36L5 7.09V8H3V5.96h-.08L0 7.9V6.85l1.35-.89Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 3.93v.1H1.59L.2 3.13c.13-.26.32-.5.55-.68L3 3.93Zm2-.88L6.59 2H8v.1L5.08 4.04H5v-.99ZM2.92 5.96H3v1L1.41 8H0v-.1l2.92-1.94Zm3.5 0L8 7.01V8h-.08L5 6.07v-.1l1.42-.01ZM8 5.43H4.44V8h-.88V5.43H0v-.86h3.56V2h.88v2.57H8v.86Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 4.97 10.25 8h3.5L12 4.97Z',
      fill: '#159570',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.25 8 8.5 11.03 12 8.9l3.5 2.14L13.75 8h-3.5Z',
      fill: '#F79A59',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm8.5 11.03 1.75-1.07.75 1.07H8.5Zm7 0-1.75-1.07-.75 1.07h2.5Z',
      fill: '#159570',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.65 8h2.7v1.69a1.35 1.35 0 0 1-2.7 0V8Z',
      fill: '#45B2E8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.65 8v1.72L12 8.9l1.35.83V8h-2.7Z',
      fill: '#fff',
    }),
  );
});
ACSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var AC = {
  category: 'flag',
  colorable: false,
  name: 'AC',
  svg: ACSvg,
};
